import React, { FC, Suspense } from 'react';

import * as Styled from './MenuLayout.styles';
import { NavLink, Outlet } from 'react-router-dom';
import { DebouncedLineLoader } from '@layout/loaders/line-loader/LineLoader';
import { useAuthContext, useAuthorization } from '@modules/auth/context';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { NotValidatedAccountModal } from '@modules/auth/components/NotValidatedAccountModal';

const MenuLayout: FC = () => {
  const canAccessAlerts = useAuthorization('alerts');
  const { profile } = useAuthContext();
  const isValidated = pipe(
    profile,
    O.fold(
      () => false,
      p => p.isValidated,
    ),
  );
  const [modalOpen, setModalOpen] = React.useState(!isValidated);

  return (
    <Styled.MenuLayoutContainer>
      <Suspense fallback={<DebouncedLineLoader />}>
        <Outlet />
      </Suspense>
      <NotValidatedAccountModal modalOpen={modalOpen} setModalOpen={setModalOpen} />

      <Styled.MenuContainer>
        <Styled.MenuContent $itemCount={canAccessAlerts ? 4 : 3}>
          <Styled.MenuItem>
            {isValidated ? (
              <NavLink to="scan" className="scan">
                Scanner <br /> une porte
              </NavLink>
            ) : (
              <span className="scan disabled">
                Scanner <br /> une porte
              </span>
            )}
          </Styled.MenuItem>

          <Styled.MenuItem>
            {isValidated ? (
              <NavLink to="doors" className="doors">
                Portes
              </NavLink>
            ) : (
              <span className="doors disabled">Portes</span>
            )}
          </Styled.MenuItem>

          {canAccessAlerts ? (
            <Styled.MenuItem>
              {isValidated ? (
                <NavLink to="alerts" className="alerts">
                  Infos résident
                </NavLink>
              ) : (
                <span className="alerts disabled">Infos résident</span>
              )}
            </Styled.MenuItem>
          ) : null}

          <Styled.MenuItem>
            <NavLink to="profile" className="profile">
              Mon profil
            </NavLink>
          </Styled.MenuItem>
        </Styled.MenuContent>
      </Styled.MenuContainer>
    </Styled.MenuLayoutContainer>
  );
};

export default MenuLayout;
